import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { LmSelectNew } from '@mes-ui/lemma';
import { Typography, useMediaQuery } from '@mui/material';
import { linkSharingDrawerActions } from 'actions';
import FunnelBlock from 'components/common/FunnelBlock';
import { useAppSelector } from 'hooks';
import { academicYearSelectValueSelector, academicYearsSelector } from 'portfolio3/features/pdf/model/selectors';
import { AcademicYearOption } from 'portfolio3/features/pdf/types';
import { createAcademicYearsSelectOptions } from 'portfolio3/features/pdf/utils/createAcademicYearsSelectOptions';
import { emitYMEvent } from 'portfolio3/features/yandexMetrika';
import { commonTheme } from 'portfolio3/styles/theme';
import { academicYearsTouchedSelector } from 'selectors/drawers/linkSharingDrawer';

import { LinkSharingTabs } from '../types';

type AcademicYearProps = {
  currentTab: LinkSharingTabs;
};
const AcademicYear = ({ currentTab }: AcademicYearProps) => {
  const dispatch = useDispatch();
  const academicYears = useAppSelector(academicYearsSelector);
  const academicYearsTouched = useAppSelector(academicYearsTouchedSelector);
  const academicYearSelectValue = useAppSelector(academicYearSelectValueSelector);
  const isMobile = useMediaQuery(commonTheme.breakpoints.down('commonSm'));
  const options = useMemo(() => createAcademicYearsSelectOptions(academicYears), [academicYears]);

  const handleChange = (chosenOptions: AcademicYearOption[]) => {
    if (!academicYearsTouched) {
      dispatch(linkSharingDrawerActions.setAcademicYearsTouched());
    }
    dispatch(linkSharingDrawerActions.changeChosenAcademicYearOptions(chosenOptions));
  };

  const handleMouseDown: React.MouseEventHandler<HTMLDivElement> = (event) => {
    const button = event.currentTarget.querySelector('button');
    if (button) {
      const buttonStyles = getComputedStyle(button);

      if (buttonStyles.transform === 'none') {
        emitYMEvent({
          type: 'sharePortfolio_yearChoice_open_click',
          payload: {
            tab: currentTab === LinkSharingTabs.LINK ? 'linkShare' : 'fileDownload',
          },
        });
      }
    }
  };

  return (
    <FunnelBlock>
      <Typography variant={isMobile ? 'Headings/H6' : 'Headings/H5'} sx={{ marginBottom: '16px' }}>
        Учебный год
      </Typography>
      <div onClick={handleMouseDown}>
        <LmSelectNew
          value={academicYearSelectValue}
          options={options}
          onChange={handleChange}
          multiple
          optionWithCheckbox
          grouped={false}
          showOptionChoiceAll
        />
      </div>
    </FunnelBlock>
  );
};

export default AcademicYear;
